import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-3 border-[#2C4A3B] border-t-transparent rounded-full animate-spin" />
          <p className="text-[#5C6B62] font-medium text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !['admin', 'super_admin', 'moderator', 'notification_admin', 'security_admin'].includes(user.role)) return <Navigate to="/dashboard" replace />;

  return children;
}
